import React, {Component} from "react";

import {Image, Nav, Navbar} from "react-bootstrap";

/**
 * @param brandContent - React Component
 * @param leftContent - Array of React components
 * @param rightContent - Array of React Components
 */
class Header extends Component {

    render() {
        const {brandContent = defaulBrandContent, leftContent = [], rightContent = []} = this.props
        return (
            <Navbar fixedTop className={'ui_hydros_navbar bg-primary'}>
                <Navbar.Header className={'headerBrand'}>
                    <Navbar.Brand className={'headerBrand'} style={{display: 'block !important'}}>
                        {brandContent}
                    </Navbar.Brand>
                </Navbar.Header>
                <Nav className={'leftNav'}>
                    {leftContent}
                </Nav>
                <Nav className={'rightNav'} pullRight>
                    {rightContent}
                </Nav>
            </Navbar>
        );
    }
}

const defaulBrandContent = <a href={'https://collierconsulting.com/services/hydros'}>
    <Image src={`https://cdn.hydroscloud.com/hydros-web/images/logos/hydros_white${PROFILE === 'development' ? '_dev' : PROFILE === 'appstest' ? '_test' : ''}.svg`} className={'img-responsive mt5 w100'}/>
</a>

export default Header;